// Auto-generated by splitter.py — do not regenerate; edit directly.

export const REFUND_REASONS = [
  'Event cancelled by organiser',
  'Duplicate / double payment',
  'Buyer requested refund',
  'Fraudulent transaction',
  'Ticket delivery failed',
  'Chargeback / dispute',
  'Other (specify in notes)',
];




/* ============================================================================
   EVENT INVENTORY — Operational stock, QR codes, seats, holds, credentials
   ============================================================================ */

// Treasury's exception kinds (GET /api/payouts/treasury/exceptions) — the Exceptions tab's and the dashboard's words.
export const EXCEPTION_KINDS = {
  overpaid: { label: 'Overpaid', tone: 'amber' },
  voided: { label: 'Cancelled', tone: 'red' },
  unplaced: { label: 'Unplaced', tone: 'amber' },
  refund: { label: 'Refund to send', tone: 'blue' },
};
